import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {Card, CardContent } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { intlShape } from 'react-intl';
import SubscriptionStatus, {
  SubscriptionStatusDetails
} from './SubscriptionStatus';
import ResourceUsage from '../resources/ResourceUsage';
import SubscriptionGreeting from '../../containers/SubscriptionGreeting';
import {Chip}  from '@material-ui/core';
import CircularProgress from '../CircularProgress';
import { Restore, Domain } from '@material-ui/icons';
import SubscriptionListItem from './SubscriptionListItem';
import DomainUsage from '../domains/DomainUsage';


/**
 * Subscription overview, with customizable actions
 * Visible in Subscription page and Product panel when the user owns a subscription
 * for the product
 */

const styles = theme => ({
  form: {
    backgroundColor: theme.form.backgroundColor
  },
  top: {
    display:'flex', 
    direction:'row', 
    justifyContent:'space-between'
  },
  spacing: {
    marginTop:18, 
    marginBottom:18,
  },
  chip: {
    color: '#447418'
  },
  card: {
    borderRadius: 12,
  }
});

class SubscriptionCard extends Component {
  render() {
    const {
      subscription,
      actions,
      classes,
    } = this.props;

    const isPlanWithDomainInvitationsSettings = !!subscription.plan.domainInvitationSettings;

    return (
      <Card className={classes.card}>
        <CardContent > 
          <div className={classes.top}>
            
              <Typography variant="h6" className={classes.title}>
                {subscription.plan && subscription.plan.name}
              </Typography>
            
              {subscription.status === 'trialing' && 
                <Chip variant="outlined" className={classes.chip} label="Free Trial" /> 
              }
          </div>
          <div className={classes.spacing}>
            <SubscriptionStatus displayPaymentInfo subscription={subscription} />
          </div>
          <SubscriptionListItem
            left={
              <CircularProgress 
                resource={{
                unit: 'licence',
                id: 'licence',
                value: subscription.usersCount || 0,
                limit: subscription.licencesCount
                }} 
                size={30}/>
            }>
            <ResourceUsage resource={{
                unit: 'licence',
                id: 'licence',
                value: subscription.usersCount || 0,
                limit: subscription.licencesCount
              }} />
          </SubscriptionListItem>
          {isPlanWithDomainInvitationsSettings &&
            <SubscriptionListItem key={"domainUsage"}
              left={
                <Domain color="primary"/>
              }
            >
              <DomainUsage subscription={subscription} />
            </SubscriptionListItem>
          }
          <SubscriptionListItem
            left={
              <Restore />
            }>
            <SubscriptionStatusDetails subscription={subscription} />
          </SubscriptionListItem>
        </CardContent>
        {actions}
        <SubscriptionGreeting subscription={subscription} />
      </Card>
    )
  }
}

SubscriptionCard.propTypes = {
  subscription: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  intl: intlShape
}

export default withStyles(styles)(
  SubscriptionCard
);


// WEBPACK FOOTER //
// ./src/components/subscriptions/SubscriptionCard.js